// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsMetallicShiny_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z" class="svg-bg"/>
  <path d="M11.9785 11.5H10.4209V7.31055C10.4209 6.85807 10.4404 6.3584 10.4795 5.81152H10.4404C10.359 6.24121 10.2858 6.55046 10.2207 6.73926L8.58008 11.5H7.29102L5.62109 6.78809C5.57552 6.66113 5.50228 6.33561 5.40137 5.81152H5.35742C5.39974 6.50163 5.4209 7.1071 5.4209 7.62793V11.5H4V4.49805H6.30957L7.74023 8.64844C7.85417 8.98047 7.93717 9.31413 7.98926 9.64941H8.01855C8.10645 9.26204 8.19922 8.92513 8.29688 8.63867L9.72754 4.49805H11.9785V11.5Z" class="svg-fg"/>
</svg>
`;
/**
 * IconRmsMetallicShiny is a generated icon component.
 */
let IconRmsMetallicShiny = IconRmsMetallicShiny_1 = class IconRmsMetallicShiny extends IconBaseElement {
    render() {
        return html `${IconRmsMetallicShiny_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsMetallicShiny.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsMetallicShiny = IconRmsMetallicShiny_1 = __decorate([
    customElement('zui-icon-rms-metallic-shiny')
], IconRmsMetallicShiny);
export { IconRmsMetallicShiny };
